import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from 'src/components/Service/ServicePrice/styles.scss';

const ProductPriceOriginal = ({ service, showFixedPrice = false, linethroughPrice = false }) => (
  <>
    {linethroughPrice ? (
      <div className={cn(styles.linethroughPrice)}>
        <h5 className="text-weight-bold">{service.startsAtPrice}</h5>
        <p className="p2 line-through n700">{service.listPrice.formatted}</p>
      </div>
    ) : (
      <span>
        {!showFixedPrice && 'Starting at'}
        <span className="text-weight-bold">{service.startsAtPrice}</span>
      </span>
    )}
  </>
);

const ProductPriceLegacyFloating = ({
  service,
  onInfo = () => {},
  className,
  showFixedPrice,
  linethroughPrice,
}) => (
  <div className={cn(styles.price, className)}>
    <ProductPriceOriginal
      service={service}
      onInfoClick={onInfo}
      showFixedPrice={showFixedPrice}
      linethroughPrice={linethroughPrice}
    />
  </div>
);

ProductPriceOriginal.propTypes = {
  service: PropTypes.shape({
    listPrice: PropTypes.shape({
      formatted: PropTypes.string,
    }),
    startsAtPrice: PropTypes.string,
  }),
  onInfoClick: PropTypes.func.isRequired,
  showFixedPrice: PropTypes.bool,
  linethroughPrice: PropTypes.bool,
};

ProductPriceLegacyFloating.propTypes = {
  service: PropTypes.object,
  className: PropTypes.string,
  onInfo: PropTypes.func.isRequired,
  showFixedPrice: PropTypes.bool,
  linethroughPrice: PropTypes.bool,
};

export default memo(ProductPriceLegacyFloating);
